import { supabase } from "@/lib/supabase";
import { Answer, OrganizationDetails } from "@/types/assessment";
import { calculateDimensionScores, calculateOverallScore, generateAssessmentReport, convertDimensionScoresToRecord } from "@/utils/scoring";
import { questions } from "@/data/questions";

export const saveAssessmentData = async (assessmentData: any) => {
  try {
    console.log("Saving assessment data with email-based approach");
    
    // Store user email in both email and created_by fields for backward compatibility
    const dataToSave = {
      ...assessmentData,
      // Keep email in the dedicated email field
      email: assessmentData.created_by,
      // created_by can be null now (the column was altered to allow this)
      created_by: null
    };
    
    console.log("Modified data to save:", dataToSave);
    
    const { data, error } = await supabase
      .from('assessments')
      .insert(dataToSave)
      .select('id')
      .single();

    if (error) {
      console.error("Error saving assessment:", error);
      throw error;
    }
    
    return { success: true, data };
  } catch (error) {
    console.error("Exception in saveAssessmentData:", error);
    throw error;
  }
};

export const generateAssessmentData = (
  organizationDetails: OrganizationDetails,
  answers: Answer[],
  userEmail: string
) => {
  try {
    console.log("Generating assessment data for:", organizationDetails.name);
    const dimensionScores = calculateDimensionScores(answers, questions);
    const overallScore = calculateOverallScore(dimensionScores);
    const report = generateAssessmentReport(dimensionScores, overallScore);
    const dimensionScoresRecord = convertDimensionScoresToRecord(dimensionScores);

    return {
      organization_details: organizationDetails,
      answers: answers,
      maturity_level: report.maturityLevel,
      overall_score: overallScore,
      dimension_scores: dimensionScoresRecord,
      description: report.description,
      created_by: userEmail // This will be used for the email field
    };
  } catch (error) {
    console.error("Error generating assessment data:", error);
    throw error;
  }
};
